import { useContext } from 'react';
import { RegistrationStatusChartsDataContext } from '../contexts/RegistrationStatusChartsDataContext';

export const useRegistrationStatusChartsDataContext = () => {
    return useContext(RegistrationStatusChartsDataContext);
};
